import { StyledBodyRow } from './StyledBodyRow';
import { StyledBodyCell } from './StyledBodyCell';

export const CustomerTableRow = ({customer, onCustomerSelect, selected}) => (
    <StyledBodyRow
        onClick={() => onCustomerSelect(customer)}
        selected={selected}
    >
        <StyledBodyCell>{customer.name}</StyledBodyCell>
        <StyledBodyCell>{customer.country}</StyledBodyCell>
        <StyledBodyCell>{customer.representative_email}</StyledBodyCell>
        <StyledBodyCell>{customer.representative_phone}</StyledBodyCell>
        <StyledBodyCell>{customer.wallet}</StyledBodyCell>
    </StyledBodyRow>
)
